import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { Lock, Download, AlertCircle } from "lucide-react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Guarda = () => {
  const { token } = useParams();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [data, setData] = useState(null);

  useEffect(() => {
    // This page must NOT be indexed by search engines
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);

    axios
      .get(`${API}/commerce/access/${token}`)
      .then((r) => {
        setData(r.data);
        setState("ok");
      })
      .catch(() => setState("error"));

    return () => {
      document.head.removeChild(meta);
    };
  }, [token]);

  return (
    <div className="App guarda-page">
      <Header />

      <div className="guarda-wrap">
        {state === "loading" && (
          <p className="commerce-loading">Verifica accesso in corso...</p>
        )}

        {state === "error" && (
          <div className="guarda-error">
            <AlertCircle size={44} strokeWidth={1.3} />
            <h1 className="serif">Accesso non valido</h1>
            <p>
              Questo link non è valido o non risulta un acquisto associato.
              Controlla il link ricevuto via email oppure contattaci.
            </p>
            <Link to="/prodotti" className="quiz-cta quiz-cta-ghost">
              <span>Torna agli strumenti</span>
            </Link>
          </div>
        )}

        {state === "ok" && data && (
          <>
            <div className="guarda-head">
              <p className="section-eyebrow">
                <Lock size={13} strokeWidth={2} style={{ marginRight: 6, verticalAlign: "middle" }} />
                Area riservata ai clienti
              </p>
              <h1 className="guarda-title serif">{data.title}</h1>
            </div>

            {data.video_id ? (
              <div className="commerce-video guarda-video">
                <iframe
                  src={`https://www.youtube.com/embed/${data.video_id}?rel=0&modestbranding=1`}
                  title={data.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                />
              </div>
            ) : (
              <p className="commerce-desc">
                Nessun video associato a questo acquisto.
              </p>
            )}

            {data.download && (
              <div className="guarda-download">
                <a
                  className="quiz-cta quiz-cta-primary"
                  href={`${API}/commerce/download/${token}`}
                >
                  <Download size={16} strokeWidth={1.8} />
                  <span>Scarica i materiali</span>
                </a>
              </div>
            )}

            <p className="guarda-note">
              Questo contenuto è riservato al tuo acquisto. Ti preghiamo di non
              condividere il link.
            </p>
          </>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Guarda;
